import React from 'react';
import { theme } from 'codeArt/components/Base';
import { Grid, GridCell } from 'codeArt/components/Layout';
import Portal from 'codeArt/components/Portal';
import Modal from 'codeArt/components/Modal';
import { twoDecimal, Util, threePosition } from 'codeArt/common';
import { getDSLabel, getDSLabelColor } from 'app/constant';
import { onComparatorChange } from 'actions/Comparator';
import { connect } from 'react-redux';
import Badge from 'codeArt/components/Badge';
import { ProgressBar } from 'codeArt/components/Progress';
import { LastMTBFChart, LastOutputChart, LastScrapRateChart, MTBFChart, OutputChart, ScrapRateChart, LastOEEChart, OEEChart } from 'app/chart';
import { DataContext } from 'app/data/context';
import BarChart from 'codeArt/components/chart/BarChart';
import DonutChart from 'codeArt/components/chart/DonutChart';
import { getRandom } from '../common';
import { Consumables as ConsumablesType } from 'app/routes/device/routes/all/detail/constant';
import { VulnerableItem } from 'app/routes/device/routes/all/detail/cost';
import { getMinMAX } from 'app/chart/common';

const size = {
  lg: 4,
  md: 6,
  sm: 12
}

export const { Scheduler, Ratio5, ConsumablesCalculator, Increase,MayIncrease, SchedulerType } = (function () {

  const interval = 1000;

  function Scheduler(calculators) {
    let timeHandle = null;

    this.start = (then) => {
      timeHandle = setTimeout(() => {
        clearTimeout(timeHandle);

        let data = {};
        calculators.forEach((c) => {
          data[c.name] = c.exec();
        });

        then(data, () => {
          this.start(then);
        });

      }, interval);
    }

    this.end = () => {
      if (timeHandle) {
        clearTimeout(timeHandle);
        timeHandle = null;
      }
    }
  }

  function Ratio5(name, value, type) {  //name:数据成员的名称
    this.name = name;
    let _initValue = value;
    let _type = type || SchedulerType.float;

    this.exec = () => {
      let ratio = Math.ceil(Math.random() * 5) / 100; // Math.random()获取从 0 到 1 的随机整数，取 0 的概率极小。\
      let _value = _initValue + _initValue * ratio;
      return handleValue(_type, _value);
    }
  }

  //每次增值 {added}值上浮动百分之30 左右
  function Increase(name, value, added, type, max) {
    this.name = name;
    let _value = value;
    let _added = added;
    let _max = max;
    let _type = type || SchedulerType.float;

    this.exec = () => {
      let v = _added + (getRandom(0, 30) / 100) * _added;
      _value = _value + v;

      if (_max && _value >= _max) _value = _max;
      return handleValue(_type, _value);
    }
  }

  function MayIncrease(name, value, added, type, probability, max) {
    this.name = name;
    let _value = value;
    let _added = added;
    let _probability = probability;
    let _type = type || SchedulerType.float;
    let _max = max;

    this.exec = () => {
      if (getRandom(1, _probability) == _probability) _value = _value + _added;
      if (_max && _value >= _max) _value = _max;
      return handleValue(_type, _value);
    }
  }

  function Consumables(name, value) {

    this.name = name;
    let consumables = value;  //消耗品的数据集合

    this.exec = () => {
      return consumables.map((c) => {
        switch (c.type) {
          case ConsumablesType.TrayPaper.Type: c.value += parseFloat(((getRandom(0, 100) / 100).toFixed(2))); break;
          case ConsumablesType.ColdGlue.Type: c.value += getRandom(0, 5); break;
          case ConsumablesType.HotGlue.Type: c.value += getRandom(0, 5); break;
          case ConsumablesType.ClothTape.Type: c.value += getRandom(0, 5); break;
          case ConsumablesType.Blade.Type: c.value += 1;
          case ConsumablesType.Bead.Type: c.value += getRandom(0, 5); break;
          case ConsumablesType.Glycerin.Type: c.value += getRandom(1, 3); break;
          case ConsumablesType.Spices.Type: c.value += getRandom(0, 5); break;
          case ConsumablesType.Tow.Type: c.value += parseFloat(((getRandom(1, 30) / 100).toFixed(2))); break;
        }

        return c;
      });
    }
  }

  function handleValue(type, value) {
    switch (type) {
      case SchedulerType.number: return parseInt(value);
      case SchedulerType.float: return parseFloat(value.toFixed(2));
      case SchedulerType.percent: return parseFloat(value.toFixed(3));
    }
  }

  const SchedulerType = {
    number: 1,
    percent: 2,
    float: 3,
  };

  return { Scheduler, Ratio5, ConsumablesCalculator: Consumables, Increase,MayIncrease, SchedulerType };
})();


class _RealTime extends React.Component {

  constructor(props) {
    super(props);
    RealTime.current = this;//单例
    this.state = {
      data: {}
    }
  }

  initMock(data) {
    this.scheduler = new Scheduler([
      new Ratio5("speed", data.speed, SchedulerType.number),
      //new Ratio5("lineSpeed", data.lineSpeed),
      new Ratio5("OEE", data.OEE),
      new Ratio5("TU", data.TU),
      new Ratio5("actualSpeed", data.actualSpeed, SchedulerType.number),
      new Increase("qualification", data.qualification, 50, SchedulerType.number),
      new Increase("scrap", data.scrap, 1, SchedulerType.number),
      new Increase("runningTime", data.runningTime, 1, SchedulerType.number),
      new Increase("shiftTime", data.shiftTime, 1, SchedulerType.number),
      new Ratio5("scrapRate", data.scrapRate, SchedulerType.percent),
      new ConsumablesCalculator("consumables", data.consumables)
    ]);

    this.scheduler.start((data, success) => {
      this.setState({
        data: { ...this.state.data, ...data }
      }, success());
    });
  }

  disposeMock() {
    if (this.scheduler) this.scheduler.end();
  }

  open(data, onRealTimeOpen, onRealTimeExit) {
    data.consumables = Util.clone(DataContext.get("REAL_TIME_CONSUMABLE"));
    data.charts = {
      output: DataContext.get("OUTPUT_REALTIME"),
      scrapRate: DataContext.get("SCRAP_RATE_REALTIME"),
      mtbf: DataContext.get("MTBF_REALTIME"),
      oee: DataContext.get("OEE_REALTIME"),
      lastOutput: DataContext.get("LAST_OUTPUT_REALTIME"),
      lastScrapRate: DataContext.get("LAST_SCRAP_RATE_REALTIME"),
      lastMTBF: DataContext.get("LAST_MTBF_REALTIME"),
      lastOEE: DataContext.get("LAST_OEE_REALTIME"),
    };

    this.setState({ data }, () => {
      this.modal.open({
        onExit: () => {
          this.disposeMock();
          if (onRealTimeExit) onRealTimeExit();
        }
      });
      if (onRealTimeOpen) onRealTimeOpen();
      this.initMock(data);
    });
  }

  close() {
    this.modal.close();
  }

  renderRatio({ className, label, value }) {
    return (
      <div className={`d-flex flex-column c-flex-1 ${className}`}>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <p className="text-muted c-text-s1 mb-0">{label}</p>
          <p className="c-text-lg-s5 c-text-sm-s2 m-text-dark75 mb-0">{value}%</p>
        </div>
        <ProgressBar foreground="#28a745" height={8} value={value} width="100%" className={"c-my-0"} />
      </div>
    );
  }

  renderRatios(data) {
    return (
      <div className="row mt-3">
        <div className="col-lg-6 col-md-12 col-sm-12 mb-3">
          {this.renderRatio({ className: "", label: "OEE", value: data.OEE })}
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 mb-3">
          {this.renderRatio({ className: "", label: "时间利用率", value: data.TU })}
        </div>
      </div>
    )
  }

  renderChart(charts) {
    if (!charts) return null;
    return (
      <div className="d-flex flex-column h-100">
        <div className="d-flex flex-lg-row flex-column c-flex-1">
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <OutputChart data={charts.output} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <ScrapRateChart data={charts.scrapRate} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <MTBFChart data={charts.mtbf} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <OEEChart data={charts.oee} />
          </div>
        </div>

      </div>
    );
  }

  renderLastChart(charts) {
    if (!charts) return null;
    return (
      <div className="d-flex flex-column h-100">
        <div className="d-flex flex-lg-row flex-column c-flex-1">
          <div className={"c-lg-flex-1 c-h-250pxc-p-1"}>
            <LastOutputChart data={charts.lastOutput} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <LastScrapRateChart data={charts.lastScrapRate} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <LastMTBFChart data={charts.lastMTBF} />
          </div>
          <div className={"c-lg-flex-1 c-h-250px c-p-1"}>
            <LastOEEChart data={charts.lastOEE} />
          </div>
        </div>
      </div>
    );
  }

  renderBarChart(data) {
    return (
      <div className="d-flex flex-column c-flex-1 c-h-300px justify-content-center align-items-center pt-4 w-100">
        <BarChart data={data} label={true} line={false} grid={{ left: 0, right: 0, bottom: 0, top: 30 }} y={{ axisLine: { "show": true }, axisTick: { "show": true }, min: 500, max: 2400, interval: 1900 }} />
      </div>)
  }

  renderPieChart(data) {
    return (
      <div className="d-flex flex-column c-flex-1 c-h-300px justify-content-center align-items-center pt-4 mx-lg-3 w-100">
        <DonutChart data={data} label={true} grid={{ left: 0, right: 0, bottom: 0, top: 30 }} />
      </div>)
  }

  // renderConsumables() {
  //   let { consumables } = this.state.data;
  //   if (!consumables) return;
  //   let data = Util.clone(consumables);
  //   return data.map((item, index) => {
  //     if (item.life <= item.value) {
  //       item.value = item.life
  //     } else {
  //       item.value = `${item.value}`.indexOf('.') > 0 ? item.value.toFixed(2) : item.value;
  //     }

  //     return VulnerableItem(item, index);
  //   });
  /*  return consumables.map((item, index) => {
     let average = `${item.average}`.indexOf('.') > 0 ? item.average.toFixed(2) : item.average;
     return <GridCell key={index} size={gridCellSize} average={true} layout={"between"} label={renderConsumable(item)} content={`${average} ${item.unit}`} has={true} />;
   }); */
  // }


  getDuration(second) {
    let hours = Math.floor((second % 86400) / 3600);
    let minutes = Math.floor(((second % 86400) % 3600) / 60);
    let seconds = Math.floor(((second % 86400) % 3600) % 60);
    return `${Util.padLeft(hours, 2, 0)}:${Util.padLeft(minutes, 2, 0)}:${Util.padLeft(seconds, 2, 0)}`
  }

  render() {
    let { data } = this.state;
    let { speed, status, qualification, runningTime, scrap, scrapRate, stickLength, downtime, shiftTime, charts } = data;

    let color = getDSLabelColor(status);
    let label = getDSLabel(status);

    let lineSpeed = (speed * stickLength).toFixed(0);

    let speedData = [
      { type: "实际速度", value: data.actualSpeed, color: theme.color.warning, format: (value, name, index) => { return ({ value: threePosition(value), name }) } },
      { type: "计划速度", value: data.planningSpeed, color: theme.color.info, format: (value, name, index) => { return ({ value: threePosition(value), name }) } }]


    let timeData = [
      { name: "停机时间", value: data.stopTime, color: theme.color.secondary, format: (value, percent) => { return percent; } },
      { name: "运行时间", value: data.runTime, color: theme.color.blue, format: (value, percent) => { return percent; } }]

    let outputData = [
      { name: "产量", value: data.totalProduction, color: theme.color.blue, format: (value, percent) => { return percent; } },
      { name: "废品总量", value: data.scrap, color: theme.color.secondary, format: (value, percent) => { return percent; } }]

    return (
      <Modal title={"设备实时状态"} ref={(r) => { this.modal = r; }} size="lg">
        <Portal {...Portal.detailModalProps}>
          <Grid>
            <GridCell size={size} average={true} layout={"between"} label="设备" content={data.Name} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="状态" content={<Badge color={color}>{label}</Badge>} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="速度" content={`${speed}支（${threePosition(lineSpeed)}米）每分钟`} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="合格的产量" content={qualification == "-" ? "-" : threePosition(qualification)} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="运行时间" content={this.getDuration(runningTime)} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="废品" content={scrap == "-" ? "-" : threePosition(data.scrap)} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="废品率" content={data.scrapRate == "-" ? "-" : `${twoDecimal(scrapRate)}%`} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="停机时间" content={this.getDuration(downtime)} has={true} />
            <GridCell size={size} average={true} layout={"between"} label="班次时间" content={this.getDuration(shiftTime)} has={true} />
          </Grid>
          {this.renderRatios(data)}


        </Portal>

        <Portal title="已消耗" {...Portal.detailModalProps}>
          <div className="row">
            <Consumables data={this.state.data} />
          </div>
        </Portal>
        <Portal title="运行时间" {...Portal.detailModalProps}>
          <div className="d-flex flex-lg-row flex-column justify-content-between align-items-center align-items-lg-center">
            {this.renderBarChart(speedData)}
            {this.renderPieChart(timeData)}
            {this.renderPieChart(outputData)}
          </div>
        </Portal>
        <Portal title="当前班次" {...Portal.detailModalProps}>
          {this.renderChart(charts)}
        </Portal>
        <Portal title="最后 小时" {...Portal.detailModalProps}>
          {this.renderLastChart(charts)}
        </Portal>

      </Modal>
    )
  }
}


const Consumables = ({ data }) => {
  let { consumables } = data;
  if (!consumables) return;
  let items = Util.clone(consumables);
  return items.map((item, index) => {
    if (item.life <= item.value) {
      item.value = item.life
    } else {
      item.value = `${item.value}`.indexOf('.') > 0 ? item.value.toFixed(2) : item.value;
    }

    return VulnerableItem(item, index);
  });
}


const mapStateToProps = ({ Comparator }) => {
  const { value } = Comparator;
  return { value };
};

export const RealTime = connect(mapStateToProps, { onComparatorChange })(_RealTime);
